import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { connect } from 'react-redux';

import {
  DropdownSelection,
  Overlay,
  ReduxState,
  Stylegroup,
} from '../../utils/interface';

const PollutantButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  transition: color 0.3s ease;
  border-radius: 4px;
  padding: 8px 16px;
  &:hover {
    color: var(--color-primary);
  }
  &.active {
    background-color: var(--color-primary);
    color: white;
    font-weight: 600;
  }
`;

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  @media screen and (max-width: 800px) {
    justify-content: space-between;
  }
`;

const PollutantList = styled.ul`
  display: flex;
  gap: 16px;
  align-items: center;
  background-color: #f9fafc;
  border-radius: 4px;
`;

type Props = {
  selections: DropdownSelection[];
  overlays: Overlay[];
  mappAirFilters: boolean;
  id: string;
  currentSelectionValue: string;
  stylegroups: Stylegroup[];
  threshold: string;
  handleSelection: Function;
  dynamicStyles?: any;
  selectedAlert?: any;
  setCurrentPollutant?: Function;
};

function PollutantSelectionPublic({
  selections,
  overlays,
  mappAirFilters,
  id,
  currentSelectionValue,
  dynamicStyles,
  stylegroups,
  threshold,
  handleSelection,
  setCurrentPollutant,
}: Props) {
  const getOverlay = (updatedSpeciesIdentifier: string) =>
    overlays.filter(
      (ol) =>
        ol.speciesIdentifier === updatedSpeciesIdentifier &&
        (mappAirFilters
          ? ol.isMappairOverlay
          : !ol.isMappairOverlay && !ol.isSAOverlay),
    )[0];

  const getItemStyle = (
    speciesValue: string,
    stylegroup: Stylegroup,
  ): React.CSSProperties => {
    const reformattedSpecie = speciesValue === 'PM2p5' ? 'PM25' : speciesValue;
    const overlay = getOverlay(speciesValue);

    const isSpeciesInThresholds = Object.keys(stylegroup.thresholds).some(
      (sg) => overlay?.name.includes(reformattedSpecie) && sg === overlay?.name,
    );

    return {
      pointerEvents: isSpeciesInThresholds ? 'initial' : 'none',
      opacity: isSpeciesInThresholds ? 1 : 0.5,
    };
  };

  const curStylegroup = stylegroups.filter(
    (group) => group.name === threshold,
  )[0];

  const handleDropdownSelection = (value: string) => {
    handleSelection(id, value);
    if (id === 'species-selection' && setCurrentPollutant)
      setCurrentPollutant(value);
  };

  const liStyle = (s: DropdownSelection) =>
    dynamicStyles && curStylegroup ? getItemStyle(s.value, curStylegroup) : {};

  return (
    <Wrapper>
      <h4>Pollutant</h4>
      <PollutantList>
        {selections.map((s) => (
          <li
            key={`${id}-${s.value}`}
            style={{
              marginRight: 0,
              ...liStyle(s),
            }}
          >
            <PollutantButton
              type="button"
              onClick={() => handleDropdownSelection(s.value)}
              className={s.value === currentSelectionValue ? 'active' : ''}
            >
              {parse(s.label)}
            </PollutantButton>
          </li>
        ))}
      </PollutantList>
    </Wrapper>
  );
}

// Redux
const mapStateToProps = (state: ReduxState) => ({
  stylegroups: state.getStyleGroups.styleGroups,
  threshold: state.setThresholdTab.tab,
  curOverlayName: state.showAQMALayer.overlay,
  overlays: state.setOverlays,
  mappAirFilters: state.mappAirFilters.showMappAirFilters,
});

export default connect(mapStateToProps, {})(PollutantSelectionPublic);
